/**
 * Glow It — Shopify theme JS (cart AJAX, product form, qty)
 */
(function () {
  'use strict';

  var routes = (window.GlowIt && window.GlowIt.routes) || {};

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
      el.textContent = String(count);
    });
    if (window.GlowIt && window.GlowIt.routes) {
      window.GlowIt.routes.cart_count = count;
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // AJAX add — Add to cart → /cart ; Buy it now → /checkout
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches('[data-product-form], .glowit-product-form, .product-form')) return;
    e.preventDefault();

    var submitter = e.submitter || document.activeElement;
    var buyNow =
      form.hasAttribute('data-buy-now') ||
      (submitter && (
        submitter.hasAttribute('data-buy-now') ||
        submitter.getAttribute('name') === 'buy_now' ||
        (submitter.classList && submitter.classList.contains('glowit-buy-now-btn'))
      ));

    var buttons = form.querySelectorAll('[type="submit"]');
    buttons.forEach(function (b) {
      b.disabled = true;
      b.setAttribute('aria-busy', 'true');
    });

    var fd = new FormData(form);
    // Avoid Shopify treating buy_now as a line-item property
    fd.delete('buy_now');

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        window.location.href = buyNow ? '/checkout' : (routes.cart_url || '/cart');
      })
      .catch(function () {
        if (buyNow) {
          var id = fd.get('id');
          var qty = fd.get('quantity') || '1';
          window.location.href = '/cart/add?id=' + encodeURIComponent(id) + '&quantity=' + encodeURIComponent(qty) + '&return_to=/checkout';
          return;
        }
        form.submit();
      })
      .finally(function () {
        buttons.forEach(function (b) {
          b.disabled = false;
          b.removeAttribute('aria-busy');
        });
      });
  });

  // Product page qty
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.quantity, .product-form__qty');
      if (!wrap) return;
      var input = wrap.querySelector('input.qty, input[name="quantity"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (btn.hasAttribute('data-qty-minus')) val = Math.max(1, val - 1);
      else val = val + 1;
      input.value = val;
    });
  });

  // Cart line qty → update form then submit change
  document.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('input[name="updates[]"][data-line="' + line + '"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      if (btn.hasAttribute('data-cart-qty-minus')) val = Math.max(0, val - 1);
      else val = val + 1;
      input.value = val;
      var form = document.getElementById('cart');
      if (form) {
        var action = document.createElement('input');
        action.type = 'hidden';
        action.name = 'update';
        action.value = 'Update';
        form.appendChild(action);
        form.submit();
      }
    });
  });

  // Product gallery thumbs (clear srcset — Shopify image_tag keeps old srcset otherwise)
  function setMainProductImage(url, alt) {
    var main = document.getElementById('ProductMainImage');
    if (!main || !url) return;
    main.src = url;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    if (alt) main.alt = alt;
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-src]');
    if (!thumb) return;
    e.preventDefault();
    var url = thumb.getAttribute('data-thumb-src');
    var thumbImg = thumb.querySelector('img');
    setMainProductImage(url, thumbImg ? thumbImg.alt : '');
    document.querySelectorAll('.glowit-thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  // Variant option change (simple products with options)
  var productJsonEl = document.querySelector('[id^="ProductJson-"]');
  var variantInput = document.getElementById('ProductVariantId');
  if (productJsonEl && variantInput) {
    try {
      var productData = JSON.parse(productJsonEl.textContent);
      var optionSelects = document.querySelectorAll('[data-option-index]');
      var syncVariant = function () {
        var selected = [];
        optionSelects.forEach(function (sel) {
          selected[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
        });
        var match = (productData.variants || []).find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        if (!match) return;
        variantInput.value = match.id;
        var priceEl = document.getElementById('ProductPrice');
        if (priceEl && match.price != null) {
          // keep simple — reload price via money is complex; show compare if any
          var money = (match.price / 100).toFixed(0);
          priceEl.innerHTML = 'Rs ' + Number(money).toLocaleString('en-PK');
        }
        var submit = document.querySelector('.product-form__submit');
        var buyNowBtn = document.querySelector('.product-form__buy-now');
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? 'Add to cart' : 'Sold out';
        }
        if (buyNowBtn) {
          buyNowBtn.disabled = !match.available;
        }
      };
      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', syncVariant);
      });
    } catch (err) { /* ignore */ }
  }
})();
